/**
 * TransactionDisplayMode
 *
 * 거래 내역 표시 방식 타입 정의
 *
 * - compact: 1줄보기 (간결 모드) - 아이콘 + 메모 + 금액만 표시
 * - full: 2줄보기 (상세 모드) - 시간, 결제수단, 지출자 정보까지 표시
 */

/**
 * 거래 내역 표시 방식 타입
 */
export type TransactionDisplayMode = 'compact' | 'full'

/**
 * 기본 표시 방식
 */
export const DEFAULT_DISPLAY_MODE: TransactionDisplayMode = 'full'

/**
 * localStorage 키
 */
export const DISPLAY_MODE_STORAGE_KEY = 'transaction-display-mode'
